<template>
    <v-dialog
        v-model="Modal.isShowing"
        persistent
        fullscreen
        transition="dialog-bottom-transition"
        no-click-animation
    >
        <v-card dark height="100%">
            <v-toolbar
                dense
                dark
                flat
                tabs
                class="headline title primary"
            >
                <v-toolbar-title>
                    {{Modal.Content ? Modal.Content.Title : ""}} &nbsp;
                </v-toolbar-title>
                <v-tabs
                    v-model="tabs"
                    color="primary"
                    slider-color="white"
                    style="flex:10"
                >
                    <v-divider vertical></v-divider>
                    <v-tab href="#modal-tab-dashboard">Dashboard</v-tab>
                    <v-divider vertical></v-divider>
                    <!-- <v-tab href="#modal-tab-definitions">Data Definitions</v-tab>
                    <v-divider vertical></v-divider> -->
                </v-tabs>
                <v-spacer></v-spacer>
                <v-btn flat @click="onCloseClick()"><span class="font-weight-light hidden-sm-and-down">Return</span></v-btn>
                <v-toolbar-side-icon flat><v-icon icon @click="onCloseClick()">exit_to_app</v-icon></v-toolbar-side-icon>
            </v-toolbar>
            <v-container fluid pa-0 ma-0>
                <v-layout>
                    <v-flex>
                        <v-tabs-items v-model="tabs">
                            <v-tab-item value="modal-tab-dashboard">
                                <div class="modal h-scroll-fix"><iframe class="fluid" :src="Modal.iFrameContent" frameborder="0"></iframe></div>
                            </v-tab-item>
                            <!-- <v-tab-item id="modal-tab-definitions">
                                <div class="modal">Content here</div>
                            </v-tab-item> -->
                        </v-tabs-items>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import Modal from '../models/App.Modal'

export default {
    data(){
        return {
            Modal,
            tabs:"modal-tab-dashboard"
        }
    },
    methods:{
        onCloseClick(){
            Modal.hide();
        }
    }
}
</script>

<style lang="scss" scoped>
.fluid{
    width:100%;
    height:100%;
}
.modal{
    height: calc(100vh - 48px); /* Full height - 48px (the toolbar absolute height) */
}
/*https://github.com/vuetifyjs/vuetify/issues/3875*/
.h-scroll-fix{
    overflow:auto;
    -webkit-overflow-scrolling:touch
}
</style>
